import React from "react";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import { ToastContainer } from "react-toastify";
import { Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Dash.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

class DashLayout extends React.Component {
  render() {
    return (
      <div>
        <PanelHeader {...this.props} />
        {this.props.children}
        <ToastContainer
          transition={Zoom}
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}

const widthConnect = connect(
  (state) => ({ user: state.user }),
  (dispatch) => bindActionCreators({}, dispatch)
);
export default widthConnect(DashLayout);
